import { Box, Typography } from '@mui/material';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center' | 'right';
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
}: SectionHeadingProps) {
  const textAlign = align;

  return (
    <Box sx={{ textAlign, mb: description ? 4 : 3 }}>
      {eyebrow && (
        <Typography
          variant="overline"
          sx={{
            letterSpacing: '0.22em',
            textTransform: 'uppercase',
            color: 'text.secondary',
          }}
        >
          {eyebrow}
        </Typography>
      )}
      <Typography
        variant="h2"
        component="h2"
        color="primary.main"
        sx={{
          fontSize: {
            xs: '1.9rem',
            sm: '2.3rem',
            md: '2.8rem',
          },
        }}
      >
        {title}
      </Typography>
      {description && (
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1.5, maxWidth: align === 'center' ? 640 : 720, mx: align === 'center' ? 'auto' : 0 }}>
          {description}
        </Typography>
      )}
    </Box>
  );
}

